import React from 'react';
import volvocx90ad from '../assets/volvoxc90.png';
import volvocx60ad from '../assets/volvoxc60.png';

const AdBanner = () => (
  <div
    style={{
      textAlign: 'center',
      margin: '20px 0',
      marginLeft: '1%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '20px',
    }}
  >
    {/* First Ad Banner */}
    <a
      href="https://www.volvocars.com/in/test-drive-booking/?utm_source=other&utm_medium=display&utm_content=xc90_static-image_300x250_Autocar&utm_campaign=in_xc90_consideration-action_2501_new-car_always-on_lead-generation&sourceapplicationinformation=in_x90_cat_nc"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img
        src={volvocx90ad}
        alt="Volvo Advertisement 1"
        style={{
          width: '100%',
          maxWidth: '1200px',
          borderRadius: '10px',
          cursor: 'pointer',
        }}
      />
    </a>

    {/* Second Ad Banner */}
    <a
      href="https://www.volvocars.com/in/test-drive-booking/?utm_source=other&utm_medium=display&utm_content=xc60_static-image_300x250_Autocar&utm_campaign=in_xc60_consideration-action_2501_new-car_always-on_lead-generation&sourceapplicationinformation=in_x60_cat_nc" // Replace with your second ad's target link
      target="_blank"
      rel="noopener noreferrer"
    >
      <img
        src={volvocx60ad} // Replace 'playground' with 'secondAdImage' when available
        alt="Volvo Advertisement 2"
        style={{
          width: '100%',
          maxWidth: '1200px',
          borderRadius: '10px',
          cursor: 'pointer',
        }}
      />
    </a>
  </div>
);

export default AdBanner;